import React from "react";
import { Box, Flex, Text, Icon, Divider, Stack, Badge, Image } from "@chakra-ui/react";
import {
  FileText,
  Package,
  User,
  Landmark,
  Hash,
  Coins,
  ClipboardCheck,
  Calendar,
  Images,
} from "lucide-react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

const ViewClaimDrawer = ({ isOpen, onClose, claim }) => {
  if (!claim) return null;

  const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/`.replace(/\/+$/, "/");

  const statusColor = (status) => {
    const s = (status || "").toLowerCase();
    if (s === "approved") return "green";
    if (s === "rejected") return "red";
    if (s === "submitted") return "blue";
    if (s === "review") return "yellow";
    return "gray";
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={
        <Text fontSize="2xl" fontWeight="bold">
          Claim Details
        </Text>
      }
      bodyContent={
        <Flex direction="column" p={8} width="100%">
          {/* Header */}
          <Box>
            <Text fontSize="2xl" fontWeight="bold">
              {claim.reason || "Claim"}
            </Text>
            <Text fontSize="sm" color="gray.500" mt={1}>
              Package Number: {claim.package.package_number}
            </Text>
          </Box>

          <Divider my={6} />

          <Flex direction="column" p={4}>
            <Box mb={6}>
              <Stack spacing={4}>
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3} align="center" justify="space-between">
                  <Flex align="center">
                    <Icon as={ClipboardCheck} mr={2} color="gray.400" />
                    <Text fontWeight="500" color="gray.600" fontSize="sm">
                      Status:
                    </Text>
                  </Flex>

                  <Badge colorScheme={statusColor(claim.status)} borderRadius="full" px={3} py={1}>
                    {claim.status || "N/A"}
                  </Badge>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={FileText} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Description: {claim.description || "N/A"}
                  </Text>
                </Flex>
{/* 
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Package} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Package ID: {claim.package_id || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={User} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Claimant ID: {claim.claimant_id || "N/A"}
                  </Text>
                </Flex> */}

                {/* Bank */}
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Landmark} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Bank Name: {claim.bank_name || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={User} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Account Name: {claim.account_name || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Hash} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Account Number: {claim.account_number || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Hash} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Branch Code: {claim.branch_code || "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Coins} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Payout Amount:{" "}
                    {claim.payout_amount != null ? `P${Number(claim.payout_amount).toFixed(2)}` : "N/A"}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Calendar} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Created At: {claim.created_at ? new Date(claim.created_at).toLocaleString() : "N/A"}
                  </Text>
                </Flex>

                {/* Images */}
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3} direction="column">
                  <Flex align="center" mb={2}>
                    <Icon as={Images} mr={2} color="gray.400" />
                    <Text fontWeight="500" color="gray.600" fontSize="sm">
                      Claim Images
                    </Text>
                  </Flex>

                  {Array.isArray(claim.claim_images) && claim.claim_images.length > 0 ? (
                    <Flex gap={3} wrap="wrap">
                      {claim.claim_images.map((img, idx) => (
                        <Image
                          key={idx}
                          src={`${BASE_URL}${img}`}
                          alt="Claim"
                          boxSize="110px"
                          objectFit="cover"
                          borderRadius="md"
                          fallbackSrc="https://via.placeholder.com/150?text=Image+Unavailable"
                        />
                      ))}
                    </Flex>
                  ) : (
                    <Text color="gray.400" fontSize="sm">
                      No claim images uploaded
                    </Text>
                  )}
                </Flex>
              </Stack>
            </Box>
          </Flex>
        </Flex>
      }
    />
  );
};

export default ViewClaimDrawer;